module.exports = __webpack_public_path__ + "static/favicon-0b5b99d2851ad3a88690370dc4dc8589.ico";